import { getFromMeta, hasInMeta } from 'Utils/router';
import store from 'Store';
import { EMAIL_VERIFICATION_ERROR_MESSAGE } from 'Config/constans';

function requestEmailVerification(to, from, next) {
  // try to get route to redirect from route meta params
  const routeToRedirect = getFromMeta(to, 'onEmailVerificationRedirect')
    // if no, redirect to settings profile tab
    || { name: 'profile-tab-tab', params: { tab: 'settings', nestedTa: 'login-credentials' } };
  store.dispatch('toaster/setMessage', {
    text: EMAIL_VERIFICATION_ERROR_MESSAGE,
    options: {
      type: 'error',
      timeout: 10000,
    },
  });
  next(routeToRedirect);
}

export function resolveEmailVerification(to, from, next) {
  const isRequiresEmailVerification = hasInMeta(to, 'requiresEmailVerification');
  if (isRequiresEmailVerification && !store.getters['login/isEmailVerified']) {
    requestEmailVerification(to, from, next);
    return Promise.reject(new Error('Email verification required'));
  }
  return Promise.resolve();
}
